import styled, { css } from 'styled-components'
import { heading } from 'styles/typography'
import mq from 'styles/mq'

export const SectionTitle = styled.h1<{ centered?: boolean }>`
  ${heading.xxxl};
  max-width: 120rem;
  text-align: left;

  ${mq.extraLarge} {
    font-size: 10.4rem;
  }

  ${props =>
    props.centered &&
    css`
      margin: auto;
    `}
`
